
import { Component, Prop, Vue} from "vue-property-decorator";
import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffoldProjects.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffold.vue";
// import ProjectModalWithButton from "@/components/companyProjects/ProjectModalWithButton.vue";
import NewProjectsDashboard from "@/components/companyProjects/newprojectsdashboard.vue";
import ProjectsIcon from "@/components/icons/ProjectsIcon.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import { findNew } from "@/helpers/cardInfoHelperFunctions/findNewHelper";
import timeRangeForNew from "@/helpers/cardInfoHelperFunctions/timeRangeForNew";
import RouteNames from "@/entities/RouteNames";
import GET_PROJECTS from "@/apollo/dashboard/GetProjects.gql";
import { Project } from "@/generated/graphql";
import CircleWithInitialsData from "@/entities/CircleWithInitialsData";
//import ProjectHoursCompletedCard from "@/components/dashboard/cards/ProjectHoursCompletedCard.vue";
//import CumulativeProjectsBudgetCard from "@/components/dashboard/cards/CumulativeProjectsBudgetCard.vue";
import ProjectsInProgressCard from "@/components/dashboard/cards/ProjectsInProgressCard.vue";
import LIST_PROJECTS from "@/apollo/projects/ListProjects.gql";
import paginationConfig from "@/data/paginationConfig";
import PaginationConfig from "@/entities/PaginationConfig";
import CUMULATIVE_PROJECTS_BUDGET from "@/apollo/projects/GetCumulativeProjectBudget.gql";
import PROJECT_HOURS from "@/apollo/projects/ProjectHours.gql";

interface Conditions {
    offset: number;
    where: {
      company: {
          id: {
            _eq: string;
          };
      };
    };
}
interface Conditions_ {  
  limit: number; 
  where: {
    completed: {
      _eq:boolean
    };
    company_id: {
            _eq: string;
          };

  };
}
@Component({
  components: {
    DashboardCardScaffold,
    // ProjectModalWithButton,
    NewProjectsDashboard,
    CardItemScaffold,
    ProjectsIcon,
    CircleWithInitials,
    //ProjectHoursCompletedCard,
    //CumulativeProjectsBudgetCard,
    ProjectsInProgressCard,

  },
  apollo: {
    dashboardProjects: {
      query: GET_PROJECTS,
      variables() {
        return this.projectsFilter
      },
      update(data) {
        return data;
      }
    },
    projectsFilterd: {
      query: CUMULATIVE_PROJECTS_BUDGET,
      variables() {
        return this.projectcurrYearsFilter
      },
      update(data) {
        return data;
      }
    },
    myprojects: {
        query: LIST_PROJECTS,
        variables() {
          return this.conditions;
        },
        update(data) {
          this.paginationConfig.total = data.total.aggregate.count;
          this.paginationConfig.loadedCount = data.project.length;
          return data.project;
        },
    },
    projectHours: {
        query: PROJECT_HOURS,
        variables() {
          return this.hoursConditions;
        },
        update(data) {
          return data.project;
        },
    }, 
  }
})
export default class DashboardProjects extends Vue {
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({type: Object, required: true}) readonly currentUser!: any;
  @Prop({ type: Boolean, default: false }) readonly isManager!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isAdmin!: boolean;

  myprojects: Project[] | undefined = undefined;
  projectsFilterd: Project[] | undefined = undefined;
  projectHours: Project[] | undefined = undefined;
  newProjectsCount : Project[] | undefined = undefined;
  
  routes = RouteNames;
  routeNames = RouteNames; 
  paginationConfig: PaginationConfig = { ...paginationConfig };
  dashboardProjects:any = null;

  get projects(): Project[] {
    if (this.dashboardProjects) {
      return this.dashboardProjects.projects;
    }
    return [];
  }
  get size(): string{
    return "project";
  }
  get inProgresshrs(): boolean{
        if(this.projectHours == undefined || this.projectHours.length == 0){
          return false;
        }
        else{
          return  true
        }
  } 
  get inProgressProjects():any{
        if(this.myprojects !== undefined){
            //@ts-ignore
            return this.myprojects.filter(x => x.completed === false);
        }
        else{
          return this.myprojects
        }
    } 
  get projectcurrYearsFilter(): any {
    const date = new Date();
    date.setMonth(date.getMonth() -12); // For subtract use minus (-)
    return {
          currYear:date
    };
  }

  get projectsTotal(): number | undefined {
    if (!this.dashboardProjects) {
      return undefined;
    }
    return this.dashboardProjects.total.aggregate.count;
  }
  get inProgressTotal(): number | undefined {
    if (!this.dashboardProjects) {
      return undefined;
    }
    return this.dashboardProjects.inProgressTotal.aggregate.count;
  }
  get projectsCompleted(): number | undefined {
    if (!this.dashboardProjects) {
      return undefined;
    }
    return this.dashboardProjects.completedTotal.aggregate.count;
  }
  get activities(): CircleWithInitialsData[] | undefined {
    if (!this.dashboardProjects?.projects) {
      return undefined;
    }
    return this.dashboardProjects.projects.reduce((arr: any[], p: any) => {
      const activities = p.project_activities.map((a: any) => {
        return {
          ...a, 
          id: p.id
        }
      });
      return arr.concat(activities)
    }, []).splice(0,5);
  }

  get activitiesTotal(): number | undefined{
    if (!this.dashboardProjects) {
      return undefined;
    }
    return this.dashboardProjects.activity_total.aggregate.count;
  }
  get projectsToRender(): undefined | CircleWithInitialsData[] {
    if (!this.projects.length) {
      return undefined;
    }
    const res = this.projects.map((p: any) => {
      return {
        name: p.name,
        id: p.id
      };
    });
    return res;
  }
  
  get newProjects(): undefined | CircleWithInitialsData[] {
    const newProjects =  this.projects.filter( (p: Project) => findNew(p.created_at, this.$moment));
    if (!newProjects.length) {
      return undefined;
    }

    return newProjects.map((p: Project) => {
      return {
        name: p.name ?? "",
        id: p.id
      };
    });
  }

  get newProjectsTotal(): number | undefined {
    if(!this.dashboardProjects) {
      return undefined;
    }
    this.newProjectsCount = this.dashboardProjects.projects.filter((d: Project) => d.project_activities_aggregate.aggregate?.sum?.confirmed_hours == null);
    return this.newProjectsCount?.length;
  }

  get projectsFilter(): any {
    return {
      projectsFilter: {archived: { _eq: false}},
      newProjectsFilter: { _and : [
        {archived: { _eq: false}},
        {created_at: {_gt: timeRangeForNew(this.$moment)}}
      ]}
    };
  }

  get offset(): number {
      const { page, limit } = this.paginationConfig;
      return (page - 1) * limit;
    }

  get empty(): boolean {
    if (!this.projects) {
      return false;
    }

    return this.projects.length === 0;
  }

  get conditions(): Conditions {
    return {
      offset: this.offset,
      where: {
        company: {
            id: {
              _eq: this.companyId,
          },
        },
      },
    };
  }
  get hoursConditions(): Conditions_ {
    return {
      limit: 5,
      where: {
        completed: {
          _eq:true
        },
        company_id: {
                _eq: this.companyId,
              },
      },
    };
  }

  get emptyListTitle(): string {
    return `Does Not Have Any Projects Yet`;
  }
  
  refetchCollection(): void {
      this.$apollo.queries.myprojects.refetch();
    }
}
